import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { formatDateTimeIST } from "../../utils/dateUtils";
import { AlertTriangle, CheckCircle2 } from "lucide-react";

export const ErrorsTab = ({ stats }) => {
  return (
    <Card data-testid="errors-tab">
      <CardHeader>
        <CardTitle className="text-base flex items-center gap-2">
          <AlertTriangle className="w-5 h-5 text-red-500" />
          Recent Errors
        </CardTitle>
        <CardDescription>Last 10 failed operations</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {stats?.recent_errors?.length === 0 ? (
            <div className="text-center py-8 text-muted-foreground">
              <CheckCircle2 className="w-12 h-12 mx-auto mb-4 text-emerald-500 opacity-50" />
              <p>No recent errors - system is healthy!</p>
            </div>
          ) : (
            stats?.recent_errors?.map((error) => (
              <div key={error.id} className="p-4 rounded-lg border border-red-500/20 bg-red-500/5">
                <div className="flex items-start justify-between">
                  <div>
                    <p className="font-medium text-red-600">{error.function_name}</p>
                    <p className="text-sm text-muted-foreground">{error.endpoint}</p>
                    {error.error_message && (
                      <p className="text-sm text-red-500 mt-2">{error.error_message}</p>
                    )}
                  </div>
                  <p className="text-xs text-muted-foreground">{formatDateTimeIST(error.timestamp)}</p>
                </div>
              </div>
            ))
          )}
        </div>
      </CardContent>
    </Card>
  );
};
